import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  base: {
    content: { color: 'gray.800' },
    closeTrigger: { top: '10px' },
  },
  variants: {
    colorPalette: {
      dark: {
        body: { bg: 'secondary.800' },
        closeTrigger: { color: 'white' },
      },
    },
    size: {
      full: {
        content: {
          borderBottomRadius: { base: 'none', md: 'lg' },
          minH: { base: 'auto', md: 'initial' },
        },
        positioner: {
          alignItems: { base: 'flex-end', md: 'center' },
        },
      },
    },
  },
});
